module.exports = __webpack_public_path__ + "img/21.50b8ec87.jpg";